import {Component, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ActivatedRoute, Router} from '@angular/router';
import {DDPTInfo} from "../model/DDPTInfo";
import {HttpService} from "../service/http.service";
import {FormsModule} from '@angular/forms';
import {BehaviorSubject} from "rxjs";
import * as Sentry from '@sentry/angular';

@Component({
  selector: 'app-card-list',
  templateUrl: './card-list.component.html',
  styleUrls: ['./card-list.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule]
})
export class CardListComponent implements OnInit {
  cards: DDPTInfo[] = [];
  cardImages: { [key: string]: string } = {};

  oib: string = '';
  licensePlate: string = '';
  companyOid: string = '';

  public isLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  constructor(
    private router: Router,
    private httpService: HttpService,
    private route: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const urlHost = window.location.hostname; // dohvaća npr. "zagrebparking.dpk.hr" ili "dpk.rao.hr"
      console.log('Hostname:', urlHost);

      // default companyOid iz query param (ako postoji)
      let paramOid = params['company-oid'] || '';

      if (urlHost.includes('zagrebparking.dpk.hr')) {
        this.companyOid = '402880a825447882012544788b750002'
        this.loadCards();

        console.log('CompanyId (Zagreb parking): ', this.companyOid);

      } else if (urlHost.includes('rao.hr')) {
        // Za rao.hr koristimo query param ili default
        this.companyOid = paramOid
        this.loadCards();

      } else {
        console.error('Nepodržana domena:', urlHost);
        this.companyOid = paramOid
      }

      console.log('companyOid:', this.companyOid);
    });
  }

  goToCardDetails(cardId: string) {
    this.router.navigate(['/dpk-details', cardId], {
      queryParams: {'company-oid': this.companyOid}
    })
  }

  search() {
    this.loadCards();
  }

  loadCards() {

    if (!this.companyOid) {
      console.error('Company OID nije postavljen.');
      return;
    }

    this.isLoading.next(true);

    const cleanLicense = this.licensePlate.replaceAll("-", "").replaceAll(" ", "").toUpperCase();

    this.httpService.getDPKList(this.oib, this.companyOid, cleanLicense)
      .subscribe({
        next: (data) => {

          if (this.companyOid.length > 0 && this.oib.length > 0 && cleanLicense.length > 0) {
            console.log('Sentry event data:', {oib: this.oib, companyOid: this.companyOid, licensePlate: cleanLicense});

            Sentry.captureEvent({
              message: 'Pretraga DDPK',
              level: 'info',

              tags: {
                type: 'loadCards',
                licensePlate: cleanLicense,
                companyOid: this.companyOid,
                oib: this.oib
              },

              extra: {
                licensePlate: cleanLicense,
                companyOid: this.companyOid,
                oib: this.oib
              }
            });
          }

          this.cards = data.sort((a: DDPTInfo, b: DDPTInfo) =>
            this.parseCustomDate(b.ddptValidFrom).getTime() - this.parseCustomDate(a.ddptValidFrom).getTime()
          );

          let imagesToLoad = this.cards.length;
          if (imagesToLoad === 0) this.isLoading.next(false);

          this.cards.forEach(card => {
            this.httpService.getImages(card.ddptOid, this.companyOid)
              .subscribe({
                next: (imageData) => {
                  let assignedImage = 'https://placehold.co/800x400';
                  if (Array.isArray(imageData) && imageData.length > 0) {
                    assignedImage = `data:image/jpeg;base64,${imageData[0]}`;
                  }
                  this.cardImages[card.ddptOid] = assignedImage;

                },
                error: (error) => {
                  console.error(`Greška pri učitavanju slike za karticu ${card.ddptOid}:`, error);

                  this.cardImages[card.ddptOid] = 'https://placehold.co/800x400';
                },
                complete: () => {
                  imagesToLoad--;
                  if (imagesToLoad === 0) this.isLoading.next(false);
                }
              });
          });
        },
        error: (error) => {
          console.error('Greška pri učitavanju kartica:', error);
          this.isLoading.next(false);

          if (this.companyOid.length > 0 && this.oib.length > 0 && cleanLicense.length > 0) {
            // ✅ Custom Sentry breadcrumb sa neuspješnim podacima
            Sentry.captureEvent({
              message: 'Pretraga DDPK sa neuspješnim podacima',
              level: 'info',

              tags: {
                type: 'loadCards',
                licensePlate: cleanLicense,
                companyOid: this.companyOid,
                oib: this.oib
              },

              extra: {
                licensePlate: cleanLicense,
                companyOid: this.companyOid,
                oib: this.oib
              }
            });
          }
        }
      });
  }

  private parseCustomDate(dateString: string): Date {
    const [datePart, timePart] = dateString.split(' ');
    const [day, month, year] = datePart.split('.').map(Number);
    const [hour, minute, second] = timePart.split(':').map(Number);
    return new Date(year, month - 1, day, hour, minute, second);
  }
}
